import React from "react";
import classes from "./AchievementStepper.module.scss";
import { MDBView, MDBRow, MDBCol, MDBMask } from "mdbreact";
import images from "../../../assets/img/app";
import StepperElement from "../../elements/stepper-element/StepperElement";

/**
 * スタンプラリー達成進捗プロパティ
 */
type AchievementStepperProprs = {
  /** 達成数 */
  achieveCount: number;
  /** 確認済み数 */
  checkedCount: number;
  /** 報酬1 */
  reward1: string;
  /** 報酬2 */
  reward2: string;
  /** 進捗1メッセージ */
  progress1: string;
  /** 進捗2メッセージ */
  progress2: string;
};

/**
 * スタンプラリー達成進捗コンポーネント
 * @param props スタンプラリー達成進捗プロパティ
 */
const AchievementStepper: React.FC<AchievementStepperProprs> = (props) => {
  return (
    <MDBView>
      <MDBRow className="align-items-center justify-content-center mb-2">
        <MDBCol size="2" className="text-center px-0">
          <StepperElement
            isAchieve={props.achieveCount > 0}
            unachievedImage={images.heart}
            achievedImage={images.heartActive}
          ></StepperElement>
        </MDBCol>
        <MDBCol size="1" className="text-center px-0">
          <img
            className="mx-auto"
            src={props.achieveCount > 2 ? images.lineActive : images.line}
            alt=""
          />
        </MDBCol>
        <MDBCol size="2" className="text-center px-0">
          <StepperElement
            isAchieve={props.achieveCount > 2}
            unachievedImage={images.points}
            achievedImage={images.pointsActive}
            topText="３つで"
            bottomText={props.reward1}
          ></StepperElement>
        </MDBCol>
        <MDBCol size="1" className="text-center px-0">
          <img
            className="mx-auto"
            src={props.achieveCount > 3 ? images.lineActive : images.line}
            alt=""
          />
        </MDBCol>
        <MDBCol size="2" className="text-center px-0">
          <StepperElement
            isAchieve={props.achieveCount > 3}
            unachievedImage={images.points}
            achievedImage={images.pointsActive}
            topText="４つで"
            bottomText={props.reward2}
          ></StepperElement>
        </MDBCol>
      </MDBRow>
      {props.achieveCount > 2 ? (
        <div
          className={`${
            classes.messageRibbon
          } text-center d-flex align-items-center justify-content-center${
            props.achieveCount === 4 ? ` ${classes.complete}` : ""
          }`}
        >
          <span>
            {props.achieveCount === 3 ? props.progress1 : ""}
            {props.achieveCount === 4 ? props.progress2 : ""}
          </span>
        </div>
      ) : (
        ""
      )}

      {props.achieveCount === 4 ? (
        <MDBMask
          className={`flex-center bg-white fadeInLeft delay-1s ${
            classes.congratsMask
          }${props.checkedCount !== 4 ? " animated" : ""}`}
        >
          <img
            src={images.congrats}
            className={`img-fluid py-2 zoomIn delay-2s${
              props.checkedCount !== 4 ? " animated" : ""
            } ${classes.widthControl}`}
            alt=""
          />
        </MDBMask>
      ) : (
        ""
      )}
    </MDBView>
  );
};

export default AchievementStepper;
